import { OrderSummary } from "./OrderSummary";
import { EmptyCart } from "../../Layout/Common/emptyCart";
import { useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

import { CheckoutSkeleton } from "../../Skeleton/checkoutSkeleton";
import { ChangeOfAddress } from "./DeliveryMethod/Delivery/ChangeOfAddress";
import { SHIPPING_METHOD } from "../../constants";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { CheckoutTitle } from "./CheckoutTitle";
import { PaymentMain } from "./Payment/PaymentMain";
import { MainContent } from "./DeliveryMethod/MainContent";
import { CSSTransition } from "react-transition-group";
import { isValidArray } from "../../Layout/Common/common";
import { useNavigate, useParams } from "react-router-dom";
import { useTillCheckoutRestore } from "../../Context/hook/useTillCheckoutRestore";
import { useTillReturnSettlement } from "../../Context/hook/useTillReturnSettlement";
import { TillSettlingOverlay } from "../../Layout/Common/tillSettlingOverlay";
import { axiosInstance } from "../../axios/axiosInstance";
import { useTillReturnBackGuard } from "../../Context/hook/useTillReturnBackGuard";
import { readTillBackPath } from "../../Context/hook/tillRedirect";
import { PAGES } from "../../routeConfig";
export const CheckoutMain = () => {
  const [restrictShipping, setRestrictShipping] = useState(false);
  const { settling, tillReturn, checkoutState } = useTillReturnSettlement();
  const { restoring, revealing } = useTillCheckoutRestore({ settling, checkoutState });

  useTillReturnBackGuard({
    active: !!tillReturn && !settling,
    backTo: readTillBackPath() || PAGES.ORDER_DETAIL,
  });
  const divcontainerRef = useRef();
  const { orderId } = useParams();
  const navigate = useNavigate();
  const {
    setPoNumber,
    setOrderCommands,
    setPromoCode,
    setDeliveryMethod,
    CartItem,
    changeAddressClicked,
    setChangeAddressClicked,
    addressBookClicked,
    setAddressBookClicked,
    smsNotificationCancelClicked,
    IsInterNational,
    pickupOnlyProduct,
    setShippingAddress,
    addressType,
    selectedAddressId,
    addressOrderId,
    setAddressOrderId,
  } = useContext(GlobalContext);

  useEffect(() => {
    const hasOverride = addressType != null || selectedAddressId != null;
    if (!hasOverride) {
      if (addressOrderId != null) setAddressOrderId(null);
      return;
    }
    if (addressOrderId == null) setAddressOrderId(CartItem ? CartItem.orderid : null);
  }, [addressType, selectedAddressId, addressOrderId, CartItem]);

  const handleAddressUpdate = (address) => {
    if (address) setShippingAddress(address);
    setChangeAddressClicked(false);
  };

  const handleAddressCancel = () => {
    setChangeAddressClicked(false);
  };
  const {
    clearSelectedShipService,
    get04MobileNumber,
    GetDefaultPaymentGateway,
    getClarificationItem,
    setSelectedShipService,
  } = useGlobalFunction();

  useEffect(() => {
    setAddressBookClicked(false);
    smsNotificationCancelClicked.current = false;
    return () => {
      setDeliveryMethod(SHIPPING_METHOD[1]);
      clearSelectedShipService();
      setPoNumber("");
      setOrderCommands("");
      setPromoCode(null);
      get04MobileNumber();
      smsNotificationCancelClicked.current = false;
    };
  }, []);

  useEffect(() => {
    if (IsInterNational === true && pickupOnlyProduct && isValidArray(pickupOnlyProduct)) {
      setRestrictShipping(true);
    } else {
      setRestrictShipping(false);
    }
  }, [IsInterNational, pickupOnlyProduct]);

  useEffect(() => {
    if (!orderId) return;
    (async () => {
      const clarifications = await getClarificationItem(orderId);
      if (clarifications && isValidArray(clarifications)) {
        navigate(`/OrderDetails/${orderId}`, { replace: true });
        return;
      }
    })();
    if (orderId) {
      console.log("No orderId found, resetting delivery method and order commands");
      const data = {
        orderId: orderId ?? "0",
      };
      axiosInstance
        .post("Shipping/loadshippingDetails", data)
        .then((response) => {
          if (response.data) {
            console.log("Shipping details orderId,", response.data);
            setSelectedShipService(response.data);
            setOrderCommands(response.data.comment);
            setPoNumber(response.data.PO_RELEASE);
          }
        })
        .catch((error) => console.log(error.message));
    } else {
      setSelectedShipService(null);
      setOrderCommands("");
    }
  }, [orderId]);

  return (
    <div className="" ref={divcontainerRef}>
      <TillSettlingOverlay show={settling || restoring || revealing} message="Confirming your payment..." />
      {restoring ? (
        <CheckoutSkeleton />
      ) : orderId || (CartItem && isValidArray(CartItem.cartItem)) ? (
        <section className="checkout-section">
          <div className="container-fluid container-lg">
            <div className="row row-equal">
              <div className="col-md-7 col-lg-7 checkout-left">
                <CSSTransition in={!changeAddressClicked} timeout={300} classNames="fade" unmountOnExit>
                  <div className="row" id="checkout-right-main">
                    <CheckoutTitle />
                    <MainContent />
                    {restrictShipping === false && <PaymentMain />}
                  </div>
                </CSSTransition>
                <CSSTransition in={changeAddressClicked} timeout={300} classNames="fade" unmountOnExit>
                  <div className="row" id="checkout-change-address">
                    <ChangeOfAddress onUpdate={handleAddressUpdate} onCancel={handleAddressCancel} />
                  </div>
                </CSSTransition>
              </div>
              <OrderSummary />
            </div>
          </div>
        </section>
      ) : CartItem && isValidArray(CartItem.cartItem) === false ? (
        <EmptyCart showHomeButton={true} />
      ) : (
        <CheckoutSkeleton />
      )}
    </div>
  );
};
